<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col col-md-12">
        <pr-input-column
          label="Niveau de risque de l'allocation proposée"
          [derrors]="derrors"
        >
          <input
            formControlName="peaRiskAllocationLevel"
            type="number"
            min="1"
            max="7"
            fraction="2"
          />
        </pr-input-column>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
